import React from 'react';
import MuiTreeView, { TreeViewProps as MuiTreeViewProps } from '@material-ui/lab/TreeView';
import { makeStyles } from 'design-system/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type TreeViewProps = MuiTreeViewProps;

const useStyles = makeStyles((_theme: $FIXME) => ({
  // TODO
}));

const TreeView = (props: TreeViewProps) => {
  const classes = useStyles(props);

  return (
    <MuiTreeView
      classes={classes}
      defaultExpanded={['1']}
      defaultCollapseIcon={<FontAwesomeIcon size="sm" icon="minus-square" />}
      defaultExpandIcon={<FontAwesomeIcon size="sm" icon="plus-square" />}
      defaultEndIcon={<FontAwesomeIcon style={{ fontSize: 8 }} size="xs" icon="minus" />}
      {...props}
    />
  );
};

export default TreeView;
